// extracted by mini-css-extract-plugin
export default {"container":"GiftCardPlastic_container__2uv2V","serial":"GiftCardPlastic_serial__5IEYh","number":"GiftCardPlastic_number__0Nxz-"};